import React from "react";
import Button from "components/button";
import { string, func, bool } from "prop-types";

const ActionContext = ({ type, onClick, text, disabled, variant }) => {
  return (
    <Button type={type} onClick={onClick} variant={variant} disabled={disabled}>
      {text}
    </Button>
  );
};

export default ActionContext;

ActionContext.defaultProps = {
  text: "Save",
  type: "submit",
  onClick: () => {},
  disabled: false,
  variant: "zltoLightBlue",
};

ActionContext.propTypes = {
  text: string,
  onClick: func,
  type: string,
  disabled: bool,
  variant: string,
};
